module.exports = __webpack_public_path__ + "static/media/9.8439ebe6.jpeg";